import _styled from"@emotion/styled";import{OrderExecutionListActionIcon}from"@wp/src/components/common/portfolioActions/styledComponents";import PortfolioScoreSelector from"@wp/src/components/screenComponents/portfolio/SidebarOverview/portfolioScoresOverview/PortfolioScoreSelector";import{Button,FlexLayout}from"@wp/src/components/common";export const OrderExecutionListDescription=_styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  padding-bottom: 24px;

  color: ${props=>props.theme.colors.neutral500};
`;export const OrderExecutionBuyHolder=_styled.span`
  color: ${props=>props.theme.colors.appGreen};
  font-weight: 500;
  text-align: right;
`;export const OrderExecutionSellHolder=_styled.span`
  color: ${props=>props.theme.colors.danger};
  text-align: right;
  font-weight: 500;
`;export const StyledOrderExecutionListActionIcon=_styled(OrderExecutionListActionIcon)`
  padding-right: 5px;
  margin-bottom: 0px;
`;export const StyledTradeButtonContentContainer=_styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
`;export const ActionsContainer=_styled.div`
  padding-top: 16px;
`;export const ActionContainer=_styled.div`
  padding: 16px 0 0 0;
`;export const ActionsRequiredTitle=_styled.div`
  font-weight: 500;
  font-size: 20px;
`;export const StepTitleText=_styled.div`
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 8px;
`;export const ConnectedBrokerageText=_styled.div`
  font-weight: 500;
  font-size: 16px;
  display: flex;
  align-items: center;
  gap: 4px;
`;export const ConnectedAccountButtonsContainer=_styled.div`
  margin-bottom: 8px;
`;export const ResponsibleWarningText=_styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  ${{"marginBottom":"0.25rem"}};
`;export const SendExecutionListEmailButton=_styled(Button)`
  width: 100%;
`;export const SendEmailStepContainer=_styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;export const SendEmailStepText=_styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  text-align: center;

  color: ${props=>props.theme.colors.neutral600};
  padding: 10px 0;
`;export const SendEmailButtonContainer=_styled.div`
  width: 100%;
`;export const StyledPortfolioScoreSelector=_styled(PortfolioScoreSelector)`
  &.ant-select {
    height: 24px;
  }
  .ant-select-selection-item {
    color: ${props=>props.theme.colors.neutral800};
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;export const CashChangeContainer=_styled(FlexLayout)`
  ${({amount})=>amount>0?{"--tw-text-opacity":"1","color":"hsl(var(--nextui-success-400) / var(--nextui-success-400-opacity, var(--tw-text-opacity)))"}:amount===0?{"color":"inherit"}:{"--tw-text-opacity":"1","color":"hsl(var(--nextui-danger-400) / var(--nextui-danger-400-opacity, var(--tw-text-opacity)))"}};
  font-weight: 500;
`;